import * as process from 'process'

export const Features = {
  enabled(feature: FeatureFlag) {
    return config[feature]
  },
}

const config = {
  ACCIDENT_OFFER_XSELL: process.env.NEXT_PUBLIC_FEATURE_ACCIDENT_OFFER_XSELL === 'true',
  // Lets developers sign and log in with a test BankID on staging. Never enable in production
  BANKID_SANDBOX: process.env.NEXT_PUBLIC_FEATURE_BANKID_SANDBOX === 'true',
  BEHAVIOR_EVENTS: process.env.NEXT_PUBLIC_FEATURE_BEHAVIOR_EVENTS === 'true',
  CAR_ADDONS: process.env.NEXT_PUBLIC_FEATURE_CAR_ADDONS === 'true',
  CAR_TRIAL_14_DAYS: process.env.NEXT_PUBLIC_FEATURE_CAR_TRIAL_14_DAYS === 'true',
  CHATBOT: process.env.NEXT_PUBLIC_FEATURE_CHATBOT === 'true',
  // We're using it to disable cookie banner outside of production and staging
  COOKIE_BANNER: process.env.NEXT_PUBLIC_FEATURE_COOKIE_BANNER === 'true',
  // Keeping it around as a way to quickly disable Insurely if anything goes wrong
  INSURELY: process.env.NEXT_PUBLIC_FEATURE_INSURELY === 'true',

  PRODUCT_PAGE_V2: process.env.NEXT_PUBLIC_FEATURE_PRODUCT_PAGE_V2 === 'true',
  QUICK_PURCHASE_V2: process.env.NEXT_PUBLIC_FEATURE_QUICK_PURCHASE_V2 === 'true',
  SWISH_PAYIN: process.env.NEXT_PUBLIC_FEATURE_SWISH_PAYIN === 'true',
  WIDGET_FEATURE_HOME_TIERS: process.env.NEXT_PUBLIC_WIDGET_FEATURE_HOME_TIERS === 'true',
  EXTERNAL_INSURANCE_CROSS_SELL: process.env.NEXT_PUBLIC_FEATURE_EXTERNAL_INSURANCE_CROSS_SELL === 'true',
} as const

export type FeatureFlag = keyof typeof config
